// Dati societari usati in piè di pagina, privacy e cookie policy.
// Fonti (29/10/2026): VIES della Commissione UE (ragione sociale e sede), scheda pubblica del
// registro imprese su aziende.it (REA e capitale). Da riconfermare con la visura camerale.
export const COMPANY = {
  ragioneSociale: "LA BOTTEGA DELLE CARNI DA MARCO - S.R.L.S.",
  sedeLegale: "Via Vincenzo Tiberio 106, 86100 Campobasso (CB)",
  sedeOperativa: "Via J. F. Kennedy 1, 86100 Campobasso (CB), all'interno del supermercato Tigre",
  piva: "01695340701",
  rea: "CB-128687",
  capitale: "€ 200,00",
  telefono: "+39 340 748 7310",
} as const;
